<template>
  <div>
    <span class="mr-10 font_small" style="width:175px;display:inline-block">通过用户名搜索用户：</span>
    <el-select
        v-model="value"
        filterable
        remote
        reserve-keyword
        placeholder="请搜索"
        :remote-method="remoteMethod"
        @change="onPersonChanged"
        :loading="loading">
        <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
  </div>
</template>

<script>

import {
  optionsOwnApi,
} from "@/api/module/user/user";


export default {

  name : 'PersonSelectOwn',

  data(){
    return {
      datas : [],
      value : "",
      selectItem: {},
      loading : false,
      options : []
    }
  },
  methods:{
    remoteMethod(query){
        if(query){
            optionsOwnApi(query)
              .then((r)=>{
                  if(r){
                      this.options = r.map((item) =>{
                          let label = item.name;
                          if(item.partyorgname){
                              label += ' - ' + item.partyorgname;
                          }
                          else {
                            if(item.unitname){
                                label += ' / ' + item.unitname;
                            }
                          }
                          
                          return {
                              id : item.id,
                              value: item.id,
                              label : label
                          }
                      })
                  }                
              })
        }
    },
    onPersonChanged(){
      this.selectItem = null;

      for(let i = 0; i < this.options.length;i++){
        if(this.options[i].value == this.value){
          this.selectItem = this.options[i];
          console.log("find item",this.options[i])
        }
      }

      this.$emit("onValueChanged",this.value,this.selectItem);
    }
  },


  mounted(){

  }
  
}
</script>

<style scoped>
.title {
  font-size: 13px;
  color: #000000;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>